"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwiftMomentDateFormats = void 0;
var SwiftMomentDateFormats = {
  lastDay: '[Yesterday]',
  sameDay: '[Today]',
  nextDay: '[Tomorrow]',
  lastWeek: '[last] dddd',
  nextWeek: 'dddd',
  sameElse: 'L'
};
exports.SwiftMomentDateFormats = SwiftMomentDateFormats;